import { createFileRoute, redirect } from "@tanstack/react-router";

// English schema alias: SoftwareApplication → /omnichannel
export const Route = createFileRoute("/software-application")({
  beforeLoad: () => {
    throw redirect({ to: "/omnichannel", replace: true });
  },
  component: () => null,
});
